import { configuration } from '../../utils/environment';
import * as imtErpQueries from './erpQueries';
import * as mockQueries from './__mocks__/queries';

const erpQueries = configuration.mockErpRequests ? mockQueries : imtErpQueries;
export const fetchCityFacts = erpQueries.fetchCityFacts;
export const fetchTripPhaseCities = erpQueries.fetchTripPhaseCities;
export const fetchTripReservingDetails = erpQueries.fetchTripReservingDetails;
